module.exports = __webpack_public_path__ + "static/media/vip.3861bc50.svg";